/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_TitleInputs */

const en_admin_credits_title = /** @type {(inputs: Admin_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const zh_admin_credits_title = /** @type {(inputs: Admin_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分管理`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Admin_Credits_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_title = /** @type {((inputs?: Admin_Credits_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_title(inputs)
	return zh_admin_credits_title(inputs)
});
export { admin_credits_title as "admin.credits.title" }